function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "37.072%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F0F0F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F0F0F5"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  fillRule: "nonzero",
  stroke: "#BEBFCB",
  d: "M29.435 15.102L15.135.56A.187.187 0 0 0 15 .5c-.05 0-.097.02-.14.065L.566 15.101a.253.253 0 0 0-.048.265.202.202 0 0 0 .184.135h3.745v14.5a1.5 1.5 0 0 0 1.48 1.5h13.738l-.867-.984c-.313-.423-.48-.818-.48-1.199 0-.292.087-.558.24-.774a1.79 1.79 0 0 1-.72-.345 1.136 1.136 0 0 1-.431-.943l-.186-2.175c-.094-.358-.026-.728.182-1.09.245-.425.652-.651 1.09-.647l.06-.008a1.502 1.502 0 0 1 .05-1.987l2.186-1.9a1.6 1.6 0 0 1 1.069-.42c.231 0 .445.052.635.15.036-.23.107-.425.215-.588.281-.425.726-.647 1.273-.66l1.572-.054V15.5h3.746c.076 0 .15-.05.183-.135a.253.253 0 0 0-.047-.264z",
  transform: "translate(.8)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#498FFF",
  d: "M31.205 24.694h-1.131a4.199 4.199 0 0 0-.322-.789l.786-.789a.72.72 0 0 0 0-1.01l-.786-.788a.721.721 0 0 0-1.006 0l-.786.789a4.884 4.884 0 0 0-.786-.324V20.71a.709.709 0 0 0-.707-.71h-1.045a.706.706 0 0 0-.715.71v1.105a5.12 5.12 0 0 0-.786.323l-.786-.789a.729.729 0 0 0-1.013 0l-.786.79a.704.704 0 0 0 0 1.009l.786.789a4.199 4.199 0 0 0-.322.789h-1.093a.706.706 0 0 0-.707.718v1.073a.712.712 0 0 0 .707.718h1.14c.077.274.185.539.322.789l-.786.789a.704.704 0 0 0 0 1.01l.786.788a.729.729 0 0 0 1.014 0l.785-.788c.253.129.516.237.786.323v1.136c0 .397.32.718.715.718h1.077a.706.706 0 0 0 .707-.718v-1.2c.27-.084.534-.192.786-.323l.786.79a.721.721 0 0 0 1.006 0l.785-.79a.72.72 0 0 0 0-1.01l-.786-.788c.137-.25.245-.515.322-.79h1.132a.717.717 0 0 0 .715-.717v-1.01a.72.72 0 0 0-.794-.75zm-5.249 3.117a1.882 1.882 0 0 1-1.878-1.886c0-1.041.841-1.885 1.878-1.885 1.038 0 1.878.844 1.878 1.885s-.84 1.886-1.878 1.886z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF8C54",
  d: "M11.3 18.333C11.3 20.4 12.8 23 15.8 23c1.117 0 2.027-.371 2.728-.94-.05.45 0 .701.079.94-.257.11-.801.499-1.003 1.08-.232.667.083 2.374.107 3.23.03 1.101.973 1.514.973 1.514a1.806 1.806 0 0 0-.077.535c-.194.388-.572.6-1.134.636l-.174.005h-3c-1 0-1.5-.52-1.499-1.558V23.723c-1.794-1.076-3-3.087-3-5.39 0-1.166 1.5-1.166 1.5 0zM15.8 16c1.243 0 2.25 1.045 2.25 2.333 0 1.289-1.007 2.334-2.25 2.334s-2.25-1.045-2.25-2.334c0-1.288 1.007-2.333 2.25-2.333zm4.5 2.333c0-1.166 1.5-1.166 1.5 0 0 .136-.005.269-.014.398-.404.141-1.486 1.216-1.92 1.555.29-.65.434-1.335.434-1.953z"
}));

var SvgConfiguracoesAd = function SvgConfiguracoesAd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConfiguracoesAd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/configuracoes-ad.f4f5416c.svg";
export { ForwardRef as ReactComponent };